// extracted by mini-css-extract-plugin
export default {"container":"Category_container__HDngD"};